import type { FaireProductEntity } from "../../entity_types/product";

export const p_7y0ufahy: FaireProductEntity = {
  token: "p_7y0ufahy",
  type: "product",
  name: "Amber & Moss - Incense Sticks",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/8c9676bb2306f74b66bb301f0da365da3107f37d16d7afd9371a8ce5f4a55b79.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b30a8b2388a0623a94a3e0ed86ff1673d18d7789c35109d97f1f216108d57d3e.jpeg",
    "https://cdn.faire.com/fastly/45cf56041d194dbe68a44cb10ab6f8d94bb95c9038ad6f1153183249b53a86b1.jpeg",
    "https://cdn.faire.com/fastly/3e5c4ce947afaa2f2a13a2ff4104969a32637e494f8f161f48c259c5b44dce62.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/41db24fd9063c264330da38383dae63613a26b7f136eac29b3b925821c80ec91.jpeg",
    "https://cdn.faire.com/fastly/9d0bd272bd3218e678e2ad4d572062a04d096c083b603c5391706273149cb761.jpeg",
  ],
  priceDollars: 5,
  description:
    'A weekend in the mountains, sun gleaming through the canopy. Notes of sage, moss, and lavender.\n\nOur hand-dipped charcoal incense quickly transforms a room: transformative smoke uplifts the space while our signature scents linger for hours even after extinguishing.\n\nEach stick burns for 1 hour; depending on room size, scent longevity lasts between 2-4 hours. 15 sticks in a plastic sleeve inside of each kraft package, measuring 10.75" long each.',
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:42.995Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
